import rest from "@/rest-client";
import createCrudVuexModule from "@/store/crud";

const store = (path) => ({
  namespaced: true,
  state: {
    isDownloading: false,

    //Datasource
    isDatasourceInventoryLoading: false,
    datasourceInventory: undefined,
    //Data
    //Datasubject
    isDatasubjectInventoryLoading: false,
    datasubjectInventory: undefined,
    // TKP-27 / 6.1: düğüm (süreç×veri) envanteri — `/fetch-process-data` (TKP-25 dilim 3)
    isProcessDataInventoryLoading: false,
    processDataInventory: undefined,
  },
  getters: {
    isDownloading: (state) => state.isDownloading ?? {},

    //Datasource
    datasourceInventory: (state) => state.datasourceInventory ?? {},
    isDatasourceInventoryLoading: (state) => state.isDatasourceInventoryLoading,
    //Datasubject
    datasubjectInventory: (state) => state.datasubjectInventory ?? {},
    isDatasubjectInventoryLoading: (state) => state.isDatasubjectInventoryLoading,
    //Datasubject
    processDataInventory: (state) => state.processDataInventory ?? {},
    isProcessDataInventoryLoading: (state) => state.isProcessDataInventoryLoading,
  },
  mutations: {
    isDownloading: (state, value) => (state.isDownloading = value),

    //Datasource
    isDatasourceInventoryLoading: (state, value) => (state.isDatasourceInventoryLoading = value),
    datasourceInventory: (state, value) => (state.datasourceInventory = value),
    removeDirectCollectMethod: (state, value) => {
      const { datasourceId, directCollectMethodId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.directCollectMethods = ds.directCollectMethods.filter((i) => i._id != directCollectMethodId);
      }
    },
    removeOtherCollectMethod: (state, value) => {
      const { datasourceId, otherCollectMethodId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.otherCollectMethods = ds.otherCollectMethods.filter((i) => i._id != otherCollectMethodId);
      }
    },
    removePhysicalArchive: (state, value) => {
      const { datasourceId, physicalArchiveId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.physicalArchives = ds.physicalArchives.filter((i) => i._id != physicalArchiveId);
      }
    },
    removeElectronicArchive: (state, value) => {
      const { datasourceId, electronicArchiveId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.electronicArchives = ds.electronicArchives.filter((i) => i._id != electronicArchiveId);
      }
    },

    removePhysicalStorage: (state, value) => {
      const { datasourceId, physicalStorageId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.physicalStorages = ds.physicalStorages.filter((i) => i._id != physicalStorageId);
      }
    },
    removeElectronicStorage: (state, value) => {
      const { datasourceId, electronicStorageId } = value;
      const ds = state.datasourceInventory[datasourceId];
      if (ds) {
        ds.electronicStorages = ds.electronicStorages.filter((i) => i._id != electronicStorageId);
      }
    },

    //Datasubject
    isDatasubjectInventoryLoading: (state, value) => (state.isDatasubjectInventoryLoading = value),
    datasubjectInventory: (state, value) => (state.datasubjectInventory = value),

    removeTransfering: (state, value) => {
      const { datasubjectId, transferingId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.transferings = ds.transferings.filter((i) => i._id != transferingId);
      }
    },

    removeProcessingLegal: (state, value) => {
      const { datasubjectId, processingLegalId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.processingLegals = ds.processingLegals.filter((i) => i._id != processingLegalId);
      }
    },

    removeProcessingPurpose: (state, value) => {
      const { datasubjectId, processingPurposeId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.processingPurposes = ds.processingPurposes.filter((i) => i._id != processingPurposeId);
      }
    },
    removeDatasubjectDatasubjectRigth: (state, value) => {
      const { datasubjectId, datasubjectDatasubjectRightId } = value;
      const ds = state.datasubjectInventory[datasubjectId];
      if (ds) {
        ds.datasubjectRights = ds.datasubjectRights.filter((i) => i._id != datasubjectDatasubjectRightId);
      }
    },

    //Data
    isProcessDataInventoryLoading: (state, value) => (state.isProcessDataInventoryLoading = value),
    processDataInventory: (state, value) => (state.processDataInventory = value),
    removeProcessDataDisposalMethod: (state, { processDataId, disposalMethodId }) => {
      const n = state.processDataInventory?.[processDataId];
      if (n) n.disposalMethods = n.disposalMethods.filter((i) => i._id != disposalMethodId);
    },
    removeProcessDataAccessAndRestriction: (state, { processDataId, accessAndRestrictionId }) => {
      const n = state.processDataInventory?.[processDataId];
      if (n) n.accessAndRestrictions = n.accessAndRestrictions.filter((i) => i._id != accessAndRestrictionId);
    },
    /** TKP-126: veri satırındaki kendi toplama/saklama/arşiv kaydı silinince yerel durumdan da düşer. */
    removeProcessDataOwnFeature: (state, { processDataId, key, itemId }) => {
      const own = state.processDataInventory?.[processDataId]?.own;
      if (own && own[key]) own[key] = own[key].filter((i) => i._id != itemId);
    },
  },
  actions: {
    async fetchDatasourceInventory({ commit }, payload) {
      commit("isDatasourceInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-datasource`, payload);
        commit("datasourceInventory", response.data);
        return response;
      } finally {
        commit("isDatasourceInventoryLoading", false);
      }
    },
    async fetchDatasubjectInventory({ commit }, payload) {
      commit("isDatasubjectInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-datasubject`, payload);
        commit("datasubjectInventory", response.data);
        return response;
      } finally {
        commit("isDatasubjectInventoryLoading", false);
      }
    },
    async fetchProcessDataInventory({ commit }, payload) {
      commit("isProcessDataInventoryLoading", true);
      try {
        const response = await rest.post(`${path}/fetch-process-data`, payload);
        commit("processDataInventory", response.data);
        return response;
      } finally {
        commit("isProcessDataInventoryLoading", false);
      }
    },

    async download({ commit }, saveInsteadofDownload) {
      commit("isDownloading", true);
      try {
        const response = await rest.post(`${path}/download`, { saveInsteadofDownload });
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
    async downloadDiff({ commit }, { saveInsteadofDownload, source, target }) {
      commit("isDownloading", true);
      try {
        const response = await rest.post(`${path}/diff/download`, { saveInsteadofDownload, source, target });
        return response;
      } finally {
        commit("isDownloading", false);
      }
    },
  },
});

export const kvkkInventory = createCrudVuexModule({
  ...store("/kvkk/inventory"),
  path: "/kvkk/inventory",
});

export const gdprInventory = createCrudVuexModule({
  ...store("/gdpr/inventory"),
  path: "/gdpr/inventory",
});
